export default "* Brummer\n* Magisk lyd\n* Shaman\n* Åndemaner";